var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFavorite = function SvgFavorite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m12 5.775-1.026 3.28a2.25 2.25 0 0 1-2.172 1.577l-3.436-.037 2.802 1.989a2.25 2.25 0 0 1 .83 2.553L7.9 18.393l2.758-2.05a2.25 2.25 0 0 1 2.684 0l2.758 2.05-1.098-3.256a2.25 2.25 0 0 1 .83-2.553l2.802-1.99-3.436.038a2.25 2.25 0 0 1-2.172-1.578L12 5.774Zm.716-2.737c-.22-.701-1.212-.701-1.432 0L9.543 8.606a.75.75 0 0 1-.724.526l-5.834-.064c-.735-.008-1.042.936-.442 1.362L7.3 13.807a.75.75 0 0 1 .276.85l-1.863 5.53c-.235.696.568 1.28 1.158.84l4.681-3.48a.75.75 0 0 1 .896 0l4.681 3.48c.59.44 1.393-.144 1.159-.84l-1.864-5.53a.75.75 0 0 1 .276-.85l4.758-3.377c.599-.426.292-1.37-.443-1.362l-5.834.064a.75.75 0 0 1-.724-.526l-1.741-5.568Z",
    fill: "#fff"
  })));
};
export default SvgFavorite;